import React from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CellContent from '../../../../../common/CellContent/CellContent';
import { generateAddress } from '../../../../../../utils/generateAddress';
import { links } from '../../../../../../constants/links';
import { setFlatsView } from '../../../../../../store/actions/housingStockActions';
import { flatsViews } from '../../../../../../constants/flatsViews';
import styles from './AddressCell.module.scss';

const AddressCell = ({ house }) => {
  const { url } = useRouteMatch();
  const history = useHistory();

  const dispatch = useDispatch();

  const handleClick = () => {
    history.push(`${url}/${house.id}/${links.house.pages.flats}`);
    dispatch(setFlatsView(flatsViews.camera));
  };

  const { countCameras = 0, countWorkCameras = 0 } = house;

  return (
    <div className={styles.root}>
      <CellContent
        topRowContent={generateAddress(house)}
        isHighlighted
        contentStyle={{
          fontSize: '18px',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      />
      <span className={styles.camerasCount}>
        Камеры: {countWorkCameras}/{countCameras}
      </span>
    </div>
  );
};

export default AddressCell;
